import React, { useState } from 'react';
import './Twocolorinjecti.css';
import BJMcolor1 from '../../../imgs/BJMcolor1.webp';
import BJMcolor2 from '../../../imgs/BJMcolor2.webp';
import BJMcolor3 from '../../../imgs/BJMcolor3.webp';
import BJMcolor4 from '../../../imgs/BJMcolor4.webp';
import Reqprodcte from "../../../components/Reqprodcte";


const images = [
    { src: BJMcolor1 },
    { src: BJMcolor2 },
    { src: BJMcolor3 },
    { src: BJMcolor4 },
];

const Twocolorinjecti = () => {
    const [current, setCurrent] = useState(0);

    const nextSlide = () => {
        setCurrent((current + 1) % images.length);
    };

    const prevSlide = () => {
        setCurrent((current - 1 + images.length) % images.length);
    };

    const goToSlide = (index) => {
        setCurrent(index);
    };

    return (
        <div className="Twocolorinj-main-container">

            <div className="Twocolorinj-slideshow">
                {images.map((img, index) => (
                    <div className={index === current ? "mySlides active" : "mySlides"} key={index}>
                        {index === current && (
                            <>
                                <img src={img.src} alt={`Slide ${index + 1}`} className="slide-image" data-aos="fade-down" />
                            </>
                        )}
                    </div>
                ))}
                <a className="prev" onClick={prevSlide}>&#10094;</a>
                <a className="next" onClick={nextSlide}>&#10095;</a>

                <div className="dots"data-aos="flip-down" >
                    {images.map((_, index) => (
                        <span
                            key={index}
                            className={index === current ? "dot active" : "dot"}
                            onClick={() => goToSlide(index)}
                        ></span>
                    ))}
                </div>
            </div>

            <div className="Twocolorinj-text">
                <h2>Two Color Injection Molding Machine</h2>
                <h3>BJM SERIES</h3>
                <p>
                    Dishatech  Two Color Injection Molding Machine are specialized for manufacturing two color plastic product. More energy saving with excellent product performance, Our advanced driving system reducing the manufacturing cost and easy to operate.</p>
                <ul>
                    <li><strong>Clamping Force:</strong> –  160~400(Ton)</li>
                    <li><strong>Shot Weight(PS):</strong> –  106~617(g)</li>

                    <li><strong>Applications :</strong> -Two Color Injection Products</li>
                </ul>
                <div className='stnd'>
                    <Reqprodcte />
                </div>            </div>
        </div>
    );
};
export default Twocolorinjecti;
